<div class="forgotpwd-block">
  <div class="container">
    <div class="card flex-grow-1 my-2">
      <div class="card-body">
        <div class="logo">
          <img src="/assets/tyre-buzzar-logo.png" alt="Tyre Buzzar Logo" width="100" />
        </div>
        <div>
          @if (showForm1) {
            <form name="forgotpwdForm" [formGroup]="forgotpwdForm" class="p-3">
              <div class="header align-left">
                <h6>Recover your password</h6>
              </div>
              <div class="form-group">
                <label for="phoneNumber">Phone number<span class="text-danger">*</span></label>
                <input formControlName="phoneNumber" id="phoneNumber"
                  class="form-control form-control-lg default-form-group-border"
                  placeholder="Phone number" required type="number" (input)="onInput($event)" />
                </div>
                @if (forgotpwdForm.get('phoneNumber')?.invalid && (forgotpwdForm.get('phoneNumber')?.dirty || forgotpwdForm.get('phoneNumber')?.touched)) {
                  <div class="errorText"
                    >
                    @if (forgotpwdForm.get('phoneNumber')?.errors?.['pattern']) {
                      <div>
                        <small class="text-danger">Please enter valid mobile number</small>
                      </div>
                    }
                    @if (forgotpwdForm.get('phoneNumber')?.errors?.['required']) {
                      <div>
                        <small class="text-danger">Mobile number is required</small>
                      </div>
                    }
                  </div>
                }
                <button type="submit" color="primary" class="btn btn-block w-100" (click)="onForgotpwd()"
                  [disabled]="!forgotpwdForm.valid">
                  Verify Phone Number
                  @if (isLoading) {
                    <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
                  }
                </button>
                @if (errorMessage) {
                  <div class="alert-danger-small">
                    {{ errorMessage }}
                  </div>
                }
              </form>
            }
          </div>
          <div>
            @if (showForm2) {
              <form #form2="ngForm" name="registerForm2" [formGroup]="registerForm2"
                class="p-3">
                <div class="form-group">
                  <label for="otp">Enter OTP</label>
                  <input formControlName="otp" id="otp"
                    class="form-control form-control-lg default-form-group-border" placeholder="Enter OTP"
                    required type="number" (input)="input($event)" />
                  </div>
                  @if (registerForm2.get('otp')?.invalid && (registerForm2.get('otp')?.dirty || registerForm2.get('otp')?.touched)) {
                    <div class="errorText"
                      >
                      @if (registerForm2.get('otp')?.errors?.['required']) {
                        <div>
                          <small class="text-danger">Otp is required</small>
                        </div>
                      }
                    </div>
                  }
                  <div class="form-group position-relative">
                    <label for="password">New password</label>
                    <div class="position-relative">
                      <input formControlName="password" id="password"
                        class="form-control form-control-lg default-form-group-border pe-5"
                        type="{{ hide ? 'password' : 'text' }}" placeholder="Password" required />
                      <div class="position-absolute end-0 top-50 translate-middle-y me-3 hide">
                        <fa-icon [icon]=" hide ? faEye : faEyeSlash" (click)="hide = !hide" [attr.aria-label]="'Hide Password'"
                        [attr.aria-pressed]="hide"></fa-icon>
                      </div>
                    </div>
                  </div>
                  @if (registerForm2.get('password')?.invalid && (registerForm2.get('password')?.dirty || registerForm2.get('password')?.touched)) {
                    <div class="errorText"
                      >
                      @if (registerForm2.get('password')?.errors?.['required']) {
                        <div>
                          <small class="text-danger">Password is required</small>
                        </div>
                      }
                    </div>
                  }
                  @if (registerForm2.get('password')?.hasError('pattern')) {
                    <div>
                      <small class="text-muted">Hint- Minimum of 6 characters with a uppercase, lowercase, special
                      character and a number required.</small>
                    </div>
                  }
                  <div class="form-group">
                    <label for="repassword">Re-enter password</label>
                    <div class="position-relative">
                      <input formControlName="repassword" id="repassword"
                        class="form-control form-control-lg default-form-group-border pe-5"
                        [type]="hide1 ? 'password' : 'text'" placeholder="Re-enter password" required />
                      <div class="position-absolute end-0 top-50 translate-middle-y me-3 hide">
                        <fa-icon [icon]=" hide1 ? faEye : faEyeSlash" (click)="hide1 = !hide1" [attr.aria-label]="'Hide Password'"
                        [attr.aria-pressed]="hide1"></fa-icon>
                      </div>
                    </div>
                    @if (registerForm2.get('repassword')?.invalid && (registerForm2.get('repassword')?.dirty || registerForm2.get('repassword')?.touched)) {
                      <div class="errorText"
                        >
                        @if (registerForm2.get('repassword')?.errors?.['required']) {
                          <div>
                            <small class="text-danger">Password is required</small>
                          </div>
                        }
                      </div>
                    }
                    @if (registerForm2.get('password')?.value !== registerForm2.get('repassword')?.value && registerForm2.get('repassword')?.touched) {
                      <div
                        >
                        Passwords do not match.
                      </div>
                    }
                  </div>
                      <div class="d-flex justify-content-between">
                        <button class="btn app-btn-primary resend-otp" (click)="resendOtp()">
                          Resend OTP
                          @if (loader) {
                            <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
                          }
                        </button>
                        <button class="btn app-btn-primary" [disabled]="registerForm2.invalid" (click)="onVerify2()">
                          Submit
                          @if (isLoading) {
                            <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
                          }
                        </button>
                      </div>
                    </form>
                  }
                  <div class="mt-2 text-danger">
                    <small class="text-danger">{{message}}</small>
                  </div>
                  <div class="button-row text-center">
                    @if (!showForm3) {
                      <a [routerLink]="['/setup-account']" class="text-link">Setup your Account</a>
                    }
                  </div>
                </div>
                <div>
                  @if (showForm3) {
                    <form name="congratsForm" class="p-3">
                      <div>
                        <div class="cong-reg text-center">
                          <i class="fa-solid fa-check"></i>
                          <h4>Congratulations!</h4>
                          <p>Your password reset process is completed. </p>
                        </div>
                      </div>
                      <div class="text-center">
                        <button class="btn app-btn-primary" [routerLink]="['/home']">
                          Go to Login
                        </button>
                      </div>
                    </form>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>